import React from "react";
import SolarCalculator from "../components/SolarCalculator";
import CTABanner from "../components/CTABanner";
import SEO from "../components/SEO";
import { FAQS } from "../lib/siteData";

export default function CalculatorPage() {
  return (
    <div data-testid="calculator-page">
      <SEO title="Solar Calculator" description="Calculate your solar savings in 30 seconds. Enter your monthly bill and get system size, cost, subsidy, savings and payback period." />
      <section className="py-16 lg:py-20 bg-gradient-to-br from-slate-900 to-blue-900 text-white">
        <div className="container-narrow">
          <div className="badge-eco bg-blue-600/20 border-blue-600/40 text-blue-300 mb-3">Solar Calculator</div>
          <h1 className="text-4xl sm:text-5xl font-heading font-bold tracking-tight mb-3">Calculate your solar savings</h1>
          <p className="text-slate-300 max-w-2xl">Enter your monthly electricity bill. In 30 seconds, you'll know your recommended system size, project cost, subsidy, savings and payback period.</p>
        </div>
      </section>

      <section className="section-pad">
        <div className="container-narrow">
          <SolarCalculator compact={false} />
        </div>
      </section>

      <section className="pb-16 bg-slate-50 section-pad">
        <div className="container-narrow max-w-3xl">
          <h2 className="font-heading text-3xl font-semibold text-slate-900 mb-8 text-center">Frequently asked questions</h2>
          <div className="space-y-3">
            {FAQS.map((f, i) => (
              <details key={i} className="bg-white rounded-xl border border-slate-200 p-5 group" data-testid={`faq-${i}`}>
                <summary className="font-heading font-semibold text-slate-900 cursor-pointer list-none flex justify-between items-center">
                  {f.q}
                  <span className="text-blue-600 group-open:rotate-45 transition">+</span>
                </summary>
                <p className="mt-3 text-sm text-slate-600 leading-relaxed">{f.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      <CTABanner />
    </div>
  );
}
